import { Box, styled } from '@material-ui/core';
import { SETVIImage, SText } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { TextColor } from '@setvi/shared/enums';

export const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 18,
  gap: 8
});

interface AILogoProps {
  fontSize?: STextProps['size'];
  iconSize?: number;
}

const AILogo = ({ fontSize = 'xl', iconSize = 15 }: AILogoProps) => (
  <Container>
    <SETVIImage src="/images/logo.png" alt="Setvi Logo" width={iconSize} />
    <SText size={fontSize} weight="semibold">
      SETVI
    </SText>
    <SText size={fontSize} weight="medium" fontColor={TextColor.Grey}>
      Intelligence
    </SText>
  </Container>
);

export default AILogo;
